import { render, staticRenderFns } from "./MailboxActions.vue?vue&type=template&id=7e1ab888&"
import script from "./MailboxActions.vue?vue&type=script&lang=js&"
export * from "./MailboxActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports